import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { Gift, Check, Sparkles, ArrowRight } from 'lucide-react';
import { PremiumButton, SectionTitle, FlowerMotif } from './premium/Decor';

const BonusSection = ({ onOpenForm }) => {
  const { language } = useLanguage();
  const isHi = language === 'hi';

  const includes = [
    { hi: 'आपके लिए लकी नंबर्स', en: 'Your Lucky Numbers' },
    { hi: 'नाम न्यूमेरोलॉजी विश्लेषण', en: 'Name Numerology Analysis' },
    { hi: 'जीवन पथ संख्या व्याख्या', en: 'Life Path Number Interpretation' },
    { hi: 'समृद्धि के योग', en: 'Yogas of Abundance' },
    { hi: 'महत्वपूर्ण तिथियाँ', en: 'Important Dates' },
    { hi: 'व्यवसाय / नौकरी मार्गदर्शन', en: 'Business / Career Guidance' },
  ];

  return (
    <section className="relative bg-white py-16 md:py-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <SectionTitle
          eyebrow={isHi ? 'विशेष उपहार' : 'Special Gift'}
          title={isHi ? 'मुफ़्त बोनस के साथ ऑर्डर करें' : 'Order With A Free Bonus'}
          subtitle={isHi
            ? 'सिर्फ़ आज: हर ऑर्डर के साथ प्रीमियम न्यूमेरोलॉजी रिपोर्ट निःशुल्क।'
            : 'Just for today: Premium Numerology Report — absolutely free with every order.'}
          language={language}
        />

        <div className="mt-12 grid lg:grid-cols-2 gap-8 lg:gap-12 items-center max-w-5xl mx-auto">
          {/* Left — bonus card */}
          <div className="relative">
            <div className="relative bg-gradient-to-br from-brand-gold-light/40 via-white to-brand-cream rounded-3xl border-2 border-brand-gold/40 shadow-premium p-8 md:p-10 overflow-hidden">
              <div className="absolute top-3 right-3 opacity-50">
                <FlowerMotif className="w-10 h-10 text-brand-gold" />
              </div>
              <div className="absolute bottom-3 left-3 opacity-30 rotate-45">
                <FlowerMotif className="w-8 h-8 text-brand-gold" />
              </div>
              <Gift className="w-12 h-12 text-brand-maroon mb-4" />
              <p className="text-xs uppercase tracking-[0.25em] text-brand-gold-dark font-semibold mb-2">
                {isHi ? 'बोनस उपहार' : 'Bonus Gift'}
              </p>
              <h3 className={`font-playfair font-bold text-2xl md:text-3xl text-brand-maroon leading-tight ${isHi ? 'font-hindi-serif' : ''}`}>
                {isHi ? 'प्रीमियम न्यूमेरोलॉजी रिपोर्ट' : 'Premium Numerology Report'}
              </h3>
              <div className="flex items-baseline gap-2 mt-3">
                <span className="font-playfair font-black text-3xl text-brand-maroon">₹0</span>
                <span className="text-brand-text-mute line-through text-lg font-outfit">₹25</span>
                <span className="bg-green-600 text-white text-xs font-bold px-2.5 py-0.5 rounded-full">FREE</span>
              </div>
              <p className={`mt-4 text-brand-text-soft text-sm md:text-base ${isHi ? 'font-hindi' : 'font-outfit'}`}>
                {isHi
                  ? 'आपकी जन्म तिथि से जुड़े छिपे रहस्य — लकी नंबर, समृद्धि की दिशा और जीवन पथ संख्या।'
                  : 'Hidden secrets from your birth date — lucky numbers, abundance direction & life-path number.'}
              </p>
            </div>
          </div>

          {/* Right — what's inside */}
          <div>
            <h3 className={`font-playfair font-bold text-2xl md:text-3xl text-brand-maroon mb-6 ${isHi ? 'font-hindi-serif' : ''}`}>
              {isHi ? 'इस रिपोर्ट में क्या मिलेगा?' : "What's Inside This Report?"}
            </h3>
            <ul className="space-y-3.5">
              {includes.map((item, i) => (
                <li key={i} className="flex items-start gap-3">
                  <span className="flex-shrink-0 w-6 h-6 rounded-full bg-brand-maroon/10 text-brand-maroon flex items-center justify-center mt-0.5">
                    <Check className="w-3.5 h-3.5" />
                  </span>
                  <span className={`text-brand-text-dark ${isHi ? 'font-hindi' : 'font-outfit'}`}>
                    {isHi ? item.hi : item.en}
                  </span>
                </li>
              ))}
            </ul>
            <div className="mt-8">
              <PremiumButton onClick={onOpenForm} size="lg">
                <Sparkles className="w-4 h-4" />
                <span className={isHi ? 'font-hindi' : 'font-outfit'}>
                  {isHi ? 'अभी मुफ़्त बोनस लें' : 'Claim Free Bonus Now'}
                </span>
                <ArrowRight className="w-4 h-4" />
              </PremiumButton>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BonusSection;
